import ReportBox from "components/ReportBox";
import { ReportModel } from "models/ReportModel";
import React, { Dispatch, SetStateAction } from "react";
import { Spinner } from "react-bootstrap";

type Props = {
  reports: ReportModel[];
  statuses;
  checkedReportsIds: number[];
  setCheckedReportsIds: Dispatch<SetStateAction<number[]>>;
};

const ReportsList = ({
  reports,
  checkedReportsIds,
  setCheckedReportsIds,
  statuses,
}: Props) => {
  return (
    <div className="reports-list">
      {reports?.length > 0 ? (
        reports?.map((report: ReportModel) => {
          return (
            <ReportBox
              report={report}
              checkedReportsIds={checkedReportsIds}
              setCheckedReportsIds={setCheckedReportsIds}
              key={report.id}
              statuses={statuses}
            />
          );
        })
      ) : (
        <Spinner />
      )}
    </div>
  );
};

export default ReportsList;
